import axios from "axios";
import store from "../store";
import authHeader from "../utils/authHeader";

const API_URL = process.env.VUE_APP_API_URL;

export const login = (user) => {
  return axios.post(API_URL + "auth/login", {
    email: user.email,
    password: user.password,
  });
};

export const logout = () => {
  localStorage.removeItem("user");
  store.state.user = ''
};

export const register = (user) => {
  return axios.post(API_URL + "auth/register", {
    email: user.email,
    password: user.password,
    name: user.name,
  });
};

export const getUser = () => {
  return axios.get(API_URL + "user/me", { headers: authHeader() });
};


export const passwordReset = (d) => {
  return axios.post(API_URL + "account/password-reset/", d, { headers: authHeader() });
};

export const passwordResettoUpdate = (d) => {
  return axios.post(API_URL + "account/update-password", d, { headers: authHeader() });
};
